<script>
  import ClickOut from '../../../../utils/directives/clickout'
  import ACL from '../../../../domain/acl/tmp-acl'
  import { mapGetters } from 'vuex'

  export default {
    name: 'btn-acoes-grv',
    props: ['task'],
    data () {
      return {
        open: false
      }
    },
    computed: {
      ACL () {
        return ACL
      },
      ...mapGetters(['isLogged', 'currentUser'])
    },
    mounted () {},
    destroyed () {
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      },
      deleteTask () {
        this.$emit('deleteTask', this.task)
      },
      forcarExecucaoTask () {
        this.$emit('forcarExecucaoTask', this.task)
      }
    },
    directives: {ClickOut}
  }
</script>

<template>

    <div class="btn-group dropdown" :class="{ open: open}" v-click-out="hide">
      <span class="btn btn-info btn-xs">Opções</span>
      <button type="button" class="btn btn-info btn-xs dropdown-toggle" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle">
        <span class="caret"></span>
        <span class="sr-only">Toggle Dropdown</span>
      </button>
      <ul class="dropdown-menu dropdown-menu-right no-padder">
        <!--<li><a class="text-danger" @click="deleteTask" v-if="ACL.check('excluir_grv', currentUser.id)"><span class="text-danger">Excluir GRV</span></a></li>-->
        <li><a @click="forcarExecucaoTask"><i class="fa fa-flash"></i> Forçar Execução</a></li>
        <li>
          <a class="text-danger" @click="deleteTask">
            <span class="text-danger">
              <i class="fa fa-remove"></i> Excluir Task</span>
          </a>
        </li>
      </ul>
    </div>
</template>



// WEBPACK FOOTER //
// BtnAcaoListaTasks.vue?7d85d616